<template>
  <div class="warning-wrapper" v-if="getshowModule(variInfo).length > 0">
    <a href="#reflashPoint"></a>
    <FTItem class="wrappertop"
    v-for="(item, index) in getshowModule(variInfo)"
    :content="item"
    :key="index">
    </FTItem>
  </div>
</template>

<script>
import FTItem from '@/components/Fund-Tip-item.vue';
import { mapGetters } from 'vuex';
import FundTypeSearch from '@/utils/FundTypeSearch';

export default {
  name: 'WarningBar',
  props: {
    topSpline: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      variInfo: 'currentFundVarietyByFundInfo',
    }),
  },
  components: {
    FTItem,
  },
  data() {
    return {
      contentList: ['根据证监会规定，3月30日起，基金公司将对旗下部分产品持续持有期少于7个自然日的投资者收取不低于1.5%的赎回费，点此了解详情>>>', '策略选基抢占年前最后上车机会策略选基抢占年前最后上车机会'],
      closable: true,
      showIcon: true,
      show: true,
      warn_red_src: '@/assets/warn-tip-red.png',
      close_src: '@/assets/warn-tip-close.png',
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.handleDefault();
  },
  methods: {
    render() {

    },
    isNewFund() {
      const { fundType } = this.$store.state.native.fund;
      return FundTypeSearch.isNewFund(fundType);
    },
    handleDefault() {},
    clickAction() {

    },
    getshowModule(variInfo) {
      if (variInfo) {
        const anList = this.getfundAnnouncementList(variInfo, 'FundAnnouncement');
        return anList;
      }
      return [];
    },
    getshowListModule(Modules, code) {
      if (Modules) {
        const showModules = Modules.filter(
          (item) => (item.ModuleCode === code && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter((item) => (item.Title.length > 0)).map((item) => {
            const result = item;
            result.show = '1';
            return result;
          });
          return CustomArray;
        }
      }
      return [];
    },
    getfundAnnouncementList(variInfo) {
      if (!variInfo) {
        return [];
      }
      const { fundannouncement } = variInfo;
      if (fundannouncement) {
        const showModules = fundannouncement;
        if (showModules.length > 0) {
          let Items = showModules;
          Items = Items.filter((item) => item.readtitle).map((item) => {
            const result = item;
            result.Title = result.readtitle;
            result.Mode = '0';
            result.HotKey = '';
            result.SubHotKey = '';
            result.SubTitle = '';
            result.Tip = '';
            result.show = '1';
            return result;
          });
          return Items;
        }
      }
      return [];
    },
    closeWarning() {
      this.show = false;
      this.$emit('closeEvent');
    },
  },
};
</script>

<style scoped lang="less">
.warning-wrapper {
  padding-left: 24px;
  padding-right: 24px;
  align-items: center;
}
.wrapper {
  background: #fff7bc;
  display: flex;
  padding-left: 25px;
  border-radius: 12px;
}

.wrappertop {
  margin-bottom: 24px;
  background: #fff7bc;
  padding-left: 25px;
  border-radius: 12px;
  display: flex;
}

.text-wrapper {
  line-height: 24px;
  flex: 1;
  align-items: center;
}

.content {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #ff4400;
}

.warn_red_img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.close_view {
  width: 50px;
  padding-right: 20px;
  text-align: right;
}

.close_img {
  width: 26px;
  height: 26px;
}
</style>
